import { MIN_Y, MAX_HEIGHT } from "../constants.js";
import { ellipseWeight, visit, writeHeight } from "./mask.js";

function clampHeight(height) {
    return Math.max(MIN_Y, Math.min(MAX_HEIGHT, Math.round(height)));
}

export default function applyCanyon(heights, resolution, layoutSize, feature, noise) {
    const depth = feature.height;
    const meanderAmp = feature.params?.meander ?? 0.35;
    const strength = feature.strength ?? 1;

    visit(feature, resolution, layoutSize, (idx, u, v) => {
        const weight = ellipseWeight(u, v, noise, feature.seed);
        if (weight <= 0) return;

        const meander = noise.noise2(u * 1.7, feature.seed * 0.017) * meanderAmp;
        const channel = Math.max(0, 1 - Math.abs(v - meander) / 0.42);
        const carve = channel * channel * weight * depth * strength;
        writeHeight(heights, idx, clampHeight(heights[idx] - carve));
    });
}
